import { createApp } from 'vue'
import App from './App.vue'
import './index.css'
import './cc-components.css'
import router from "./router";
import store from "./store";
// import smoothscroll from 'smoothscroll-polyfill'
import { autoAnimatePlugin } from '@formkit/auto-animate/vue'
// import VueVirtualScroller from "vue-virtual-scroller";
// import "vue-virtual-scroller/dist/vue-virtual-scroller.css";
import VCalendar from 'v-calendar';
import 'v-calendar/style.css';
import { Amplify } from "aws-amplify";
import { CookieStorage } from 'aws-amplify/utils';
import { cognitoUserPoolsTokenProvider } from 'aws-amplify/auth/cognito';
import awsconfig from './aws-exports';
import { applyPortalHandoff } from './util/sessionHandoff';

// Font Awesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import './icons.js' // add icons to library

Amplify.configure(awsconfig);
cognitoUserPoolsTokenProvider.setKeyValueStorage(
  new CookieStorage({
    domain: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? undefined : '.cruzcontrol.app', // share across subdomains
    path: '/',
    expires: 365,
    sameSite: 'lax',
    secure: import.meta.env.VITE_DEV_NETWORK_ACCESS === "true" ? false : true
  })
);

// Before anything reads sessionTimestamp: adopt the portal's activity stamp if we
// arrived via handoff, so a stale local clock can't log out a brand new session.
applyPortalHandoff(store);

// smoothscroll.polyfill()

const app = createApp(App)

app.use(router)
app.use(store)
app.use(VCalendar, {})
// app.use(VueVirtualScroller)
app.use(autoAnimatePlugin)

// Markdown editor for admin announcements
import VMdEditor from '@kangc/v-md-editor'
import '@kangc/v-md-editor/lib/style/base-editor.css'
import githubTheme from '@kangc/v-md-editor/lib/theme/github.js'
import '@kangc/v-md-editor/lib/theme/style/github.css'
import enUS from '@kangc/v-md-editor/lib/lang/en-US';
VMdEditor.use(githubTheme)
VMdEditor.lang.use('en-US', enUS);
app.use(VMdEditor)
// eslint-disable-next-line vue/component-definition-name-casing
app.component('font-awesome-icon', FontAwesomeIcon)
app.config.productionTip = false

// match user system theme if no cookie stored
const theme = store.state.theme
console.log("theme in cookie:", theme)
if (!theme) {
  store.commit(
    'setTheme',
    window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light'
  )
} else {
  store.commit('setTheme', theme)
}

app.mount('#app');
